import { graphql } from "generated/gql";

export const CoreOrganisationFieldsFragment = graphql(/* GraphQL */ `
  fragment MeOrganisationFields on Organisation {
    id
    name
    subdomain
    avatarUrl
    taxaInterpretationEnabled
  }
`);

export const CoreCollectionSitesFieldsFragment = graphql(/* GraphQL */ `
  fragment MeCollectionSitesFields on CollectionSite {
    id
    name
    urlSlug
    materialQualifierFormat
    mapCenterLongitude
    mapCenterLatitude
    mapZoomLevel
    public
    publicAbout
    publicWebsite
    publicContactEmail
    publicCountry {
      codeId
      name
      countryCodeAlpha2
    }
    publicCountryCode
    publicLocation
    publicDefaultBaseMapId
    members(filter: {deactivated: false}) {
      id
      initials
      avatarUrl
      email
    }
    ipenNumbersEnabled
    tagNumbersEnabled
    sexEnabled
    identificationFieldsEnabled
    baseMap {
      id
      name
      url
      attribution
      minZoom
      maxZoom
    }
  }
`);

export const CollectionSiteMembershipFieldsFragment = graphql(/* GraphQL */ `
  fragment CollectionSiteMembershipFields on CollectionSiteMembership {
    collectionSiteId
    userId
    id
  }
`);

export const getMeWithSitesDocument = graphql(/* GraphQL */ `
  query GetMeOrgWithSites {
    me {
      id
      email
      givenName
      familyName
      collectionSiteMemberships {
        ...CollectionSiteMembershipFields
      }
      organisation {
        ...MeOrganisationFields
      }
      collectionSites {
        ...MeCollectionSitesFields
      }
    }
  }
`);

export const getCollectionSiteDocument = graphql(/* GraphQL */ `
  query GetCollectionSite($id: ID!) {
    collectionSite(id: $id) {
      urlSlug
      name
      id
      materialQualifierFormat
      baseMap {
        id
        name
        url
        attribution
        minZoom
        maxZoom
      }
      ipenNumbersEnabled
      identificationFieldsEnabled
      tagNumbersEnabled
      sexEnabled
      public
      publicAbout
      publicWebsite
      publicContactEmail
      publicCountry {
        codeId
        name
        countryCodeAlpha2
      }
      publicCountryCode
      publicLocation
    }
  }
`);

export const createSiteMembershipDocument = graphql(/* GraphQL */ `
  mutation CreateCollectionSiteMembership(
    $input: CreateCollectionSiteMembershipInput!
  ) {
    createCollectionSiteMembership(input: $input) {
      success
    }
  }
`);

export const deleteSiteMembershipDocument = graphql(/* GraphQL */ `
  mutation DeleteCollectionSiteMembership($id: String!) {
    deleteCollectionSiteMembership(id: $id) {
      success
    }
  }
`);
